import React, { useEffect, useState, useRef } from "react";
import { doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth"; // Import onAuthStateChanged
import { auth, db } from "../../Security/firebase-config";
import "../General-Page.css";
// import "./Bind-Gekko.css";
import "../../utils/ImageHoverEffect.css";
import { applyImageZoomEffect } from '../../utils/ImageHoverEffect';
import Footer from "../../components/core-components/Footer";
import GuideImage from "../../components/core-components/GuideImage";
import Highlight from "../../components/core-components/Highlight";
import Favorites from "../../components/core-components/Favorites";
import GuideMediaPlaceholder from "../../components/core-components/GuideMediaPlaceholder";
import { useBlur } from "../../context/BlurContext";
import { buildPlannedGuideAssetPath } from "../../utils/guideMediaPlanning";

const PLANNED_DISCORD_BLACK = buildPlannedGuideAssetPath("discordblack.png");
const PLANNED_DISCORD_GREY = buildPlannedGuideAssetPath("discordgrey.png");
const PLANNED_DISCORD_RED = buildPlannedGuideAssetPath("discordred.png");
const PLANNED_DEFAULTING_STRATEGY = buildPlannedGuideAssetPath("defaulting-strategy.png");


const BindGekko= () => {
  const [userTeamId, setUserTeamId] = useState(null);
  const imageContainerRef = useRef(null);
  const { isBlurred } = useBlur(); // Access blur state
  const [selectedImage, setSelectedImage] = useState("image1");


  useEffect(() => {
    if (imageContainerRef.current) {  // ✅ Ensure the element exists
      const cleanup = applyImageZoomEffect(imageContainerRef.current); 
  
      return () => {
        cleanup();
      };
    }
  }, []);  

  useEffect(() => {
    console.log("userTeamId in BindMapApproach:", userTeamId);
  }, [userTeamId]);

  useEffect(() => {
    const fetchUserTeamId = async (uid) => {
      try {
        const userDocRef = doc(db, "users", uid);
        console.log("Fetching user document:", userDocRef.path); // Log the Firestore path
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
          const data = userDocSnap.data();
          console.log("Fetched user document data:", data); // Log the document data

          if (data.teamId) {
            console.log("Setting teamId:", data.teamId);
            setUserTeamId(data.teamId);
          } else {
            console.warn("No teamId found in user document. Setting teamId to null.");
            setUserTeamId(null);
          }
        } else {
          console.error("User document does not exist in Firestore.");
        }
      } catch (error) {
        console.error("Error fetching user team ID:", error);
      }
    };

    // Listen for authentication state changes
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        console.log("User is authenticated:", user.uid);
        fetchUserTeamId(user.uid); // Pass the UID to fetch the teamId
      } else {
        console.warn("No authenticated user found.");
        setUserTeamId(null); // Clear the teamId if the user logs out
      }
    });

    // Cleanup the listener on unmount
    return () => unsubscribe();
  }, []);

  // Page transition effect
  useEffect(() => {
    document.body.classList.add("no-transition");
    const pageContainer = document.querySelector(".page__container");
    pageContainer && pageContainer.classList.add("no-transition");

    const handleLoad = () => {
      document.body.classList.remove("no-transition");
      pageContainer && pageContainer.classList.remove("no-transition");
    };

    window.addEventListener("load", handleLoad);

    return () => {
      window.removeEventListener("load", handleLoad);
    };
  }, []);

  const renderARetakeMedia = () => {
    if (selectedImage === "image1") {
      return <GuideImage src="/assets/Ind-Bind/Bind-Gekko-A-Retake-w-only-CT-Space-Cropped.png" alt="A-Retake" />;
    }

    if (selectedImage === "image2") {
      return (
        <GuideMediaPlaceholder
          label="1) Moshpit Lineup"
          plannedAssetPath={PLANNED_DISCORD_GREY}
        />
      );
    }

    return (
      <GuideMediaPlaceholder
        label="2) Dizzy Lineup"
        plannedAssetPath={PLANNED_DISCORD_RED}
      />
    );
  };


  return (
    <div className={`page__container ${isBlurred ? "blurred-content" : ""}`}>
    <Highlight />
    <main className={`Main__content__container ${isBlurred ? "blurred-content" : ""}`}>
      <h1 className="M-A-Title">Bind Gekko</h1> {/* Page Title */}

      <ul className="accordian">

        {/* Defense Main Accordion */}
        <li>
          <input type="checkbox" name="accordian" id="Indiv-Bind-Gekko-Defense-Main" />
          <label htmlFor="Indiv-Bind-Gekko-Defense-Main">Defense</label>
          <div className="accordian__content">

            {/* Defensive Positioning */}
            <li>
              <input type="checkbox" name="Defense-sub" id="Indiv-Bind-Gekko-Defensive-Positioning" />
              <label htmlFor="Indiv-Bind-Gekko-Defensive-Positioning">
                Defensive Positioning
                <Favorites headingId="Indiv-Bind-Gekko-Defensive-Positioning" headingContent="Defensive Positioning" pageLocation="/Bind-Gekko" teamId={userTeamId} />
              </label>
              <div className="accordian__content"><p>Content about defensive positioning...</p></div>
            </li>

            {/* Pathing */}
        <li>
          <input type="checkbox" name="Defense-sub" id="Indiv-Bind-Gekko-Pathing" />
          <label htmlFor="Indiv-Bind-Gekko-Pathing">
          Pathing
          <Favorites headingId="Indiv-Bind-Gekko-Pathing" headingContent="Pathing" pageLocation="/Bind-Gekko" teamId={userTeamId} />
          </label>
          <div className="accordian__content">
          <p>
            Gekko should not remain as an anchor. Instead, he thrives when **pushing space**, 
            **fighting with the team**, or **rotating to support site holds**.
          </p>
          <p>
            Understanding Gekko's role in **different types of retakes** is crucial. 
            More precise pathing strategies for retakes are covered in the individual retake descriptions.
          </p>
          </div>
        </li>


            {/* Defensive Set-Plays */}
            <li>
              <input type="checkbox" name="Defense-sub" id="Indiv-Bind-Gekko-Defensive-Set-Plays" />
              <label htmlFor="Indiv-Bind-Gekko-Defensive-Set-Plays">
                Defensive Set-Plays
                <Favorites headingId="Indiv-Bind-Gekko-Defensive-Set-Plays" headingContent="Defensive Set-Plays" pageLocation="/Bind-Gekko" teamId={userTeamId} />
              </label>
              <div className="accordian__content">
                <li><input type="checkbox" name="DefensiveSetPlays-sub" id="Indiv-Bind-Gekko-Eco-Strats" /><label htmlFor="Indiv-Bind-Gekko-Eco-Strats">Eco Strats</label><div className="accordian__content"><p>Content about eco strats...</p></div></li>
                <li><input type="checkbox" name="DefensiveSetPlays-sub" id="Indiv-Bind-Gekko-Trap-Plays" /><label htmlFor="Indiv-Bind-Gekko-Trap-Plays">Trap Plays</label><div className="accordian__content"><p>Content about trap plays...</p></div></li>
                <li><input type="checkbox" name="DefensiveSetPlays-sub" id="Indiv-Bind-Gekko-Plans-Ultimates" /><label htmlFor="Indiv-Bind-Gekko-Plans-Ultimates">Plans around Ultimate's</label><div className="accordian__content"><p>Content about ultimate-based plans...</p></div></li>
              </div>
            </li>

            {/* Retake */}
            <li>
              <input type="checkbox" name="Defense-sub" id="Indiv-Bind-Gekko-Retake" />
              <label htmlFor="Indiv-Bind-Gekko-Retake">
                Retake
                <Favorites headingId="Indiv-Bind-Gekko-Retake" headingContent="Retake" pageLocation="/Bind-Gekko" teamId={userTeamId} />
              </label>
              <div className="accordian__content">
                <li><input type="checkbox" name="Retake-sub" id="Indiv-Bind-Gekko-Standard-Retake" /><label htmlFor="Indiv-Bind-Gekko-Standard-Retake">Standard Retake</label><div className="accordian__content"><p>Content about standard retakes...</p></div></li>
                
                {/* A-Retake with only CT control */}
                <li>
                  <input type="checkbox" name="StandardRetake-sub" id="Indiv-Bind-Gekko-A-Retake-Only-CT-Control" />
                  <label htmlFor="Indiv-Bind-Gekko-A-Retake-Only-CT-Control">A-Retake with only CT control</label>
                  <div className="accordian__content">

                    {/* Image Selector Container */}
                    <div className="image-selector">
                      <button onClick={() => setSelectedImage("image1")} className={selectedImage === "image1" ? "active" : ""}>Overview</button>
                      <button onClick={() => setSelectedImage("image2")} className={selectedImage === "image2" ? "active" : ""}>1&#41; Moshpit Lineup</button>
                      <button onClick={() => setSelectedImage("image3")} className={selectedImage === "image3" ? "active" : ""}>2&#41; Dizzy Lineup</button>
                    </div>

                    {/* Content Wrapper for Image and Text */}
                    <div className="retake-content__wrapper">
                      
                      {/* Image Container */}
                      <div className="retake-image__container">
                        {renderARetakeMedia()}
                      </div>

                      {/* Text Container */}
                      <div className="retake-text__container">
                        <p>
                          Depending on which area is being controlled, execute your retake with calculated aggression. 
                          Adapt positioning based on your remaining utility and the enemy's expected setup.
                        </p>
                      </div>

                    </div>

                  </div>
                </li>

                <li><input type="checkbox" name="Retake-sub" id="Indiv-Bind-Gekko-Retake-Ultimates" /><label htmlFor="Indiv-Bind-Gekko-Retake-Ultimates">Retake with Ultimate's</label><div className="accordian__content"><p>Content about ult-based retakes...</p></div></li>
                <li><input type="checkbox" name="Retake-sub" id="Indiv-Bind-Gekko-Flooding-Site" /><label htmlFor="Indiv-Bind-Gekko-Flooding-Site">Flooding Site</label><div className="accordian__content"><p>Content about flooding site retakes...</p></div></li>
              </div>
            </li>

          </div>
        </li>

        {/* Attack Main Accordion */}
        <li>
          <input type="checkbox" name="accordian" id="Indiv-Bind-Gekko-Attack-Main" />
          <label htmlFor="Indiv-Bind-Gekko-Attack-Main">Attack</label>
          <div className="accordian__content">

            {/* Attack Pre-round Positioning */}
            <li>
              <input type="checkbox" name="Attack-sub" id="Indiv-Bind-Gekko-Attack-Pre-round-Positioning" />
              <label htmlFor="Indiv-Bind-Gekko-Attack-Pre-round-Positioning">
                Attack Pre-round Positioning
                <Favorites headingId="Indiv-Bind-Gekko-Attack-Pre-round-Positioning" headingContent="Attack Pre-round Positioning" pageLocation="/Bind-Gekko" teamId={userTeamId} />
              </label>
              <div className="accordian__content"><p>Content about attack pre-round positioning...</p></div>
            </li>

        {/* How to Default As Gekko */}
        <li>
          <input type="checkbox" name="Attack-sub" id="Indiv-Bind-Gekko-How-to-Default-As-Gekko" />
          <label htmlFor="Indiv-Bind-Gekko-How-to-Default-As-Gekko">
            How to Default As Gekko
            <Favorites headingId="Indiv-Bind-Gekko-How-to-Default-As-Gekko" headingContent="How to Default As Gekko" pageLocation="/Bind-Gekko" teamId={userTeamId} />
          </label>
          <div className="accordian__content">
            
            {/* Content Wrapper for Flexbox Layout */}
            <div className="Bind-content__wrapper">
              
              {/* Image on the Left */}
              <div className="Bind-image__container">
                <GuideMediaPlaceholder
                  label="Gekko Defaulting"
                  plannedAssetPath={PLANNED_DISCORD_BLACK}
                />
              </div>

              {/* Text on the Right */}
              <div className="Bind-text__container">
                <p>
                  If there is a **Skye** on your team and you are running a **1/1/1/2 default**, 
                  Skye and your duelist should focus on controlling **one of the Zone 2 spaces** while you 
                  hold passively as a solo.
                </p>
                <p>
                  However, in a **2/2/1 default** or if your team lacks a **drone initiator**, 
                  you should actively **take space with your duelist**.
                </p>
                <p>
                  **Do not hesitate** to use both **Wingman** and **Dizzy** to contest space! Since you are defaulting, 
                  you are not committing to an immediate site hit, meaning the **10-second cooldown** is negligible.
                </p>
                <GuideMediaPlaceholder
                  label="Defaulting Strategy"
                  plannedAssetPath={PLANNED_DEFAULTING_STRATEGY}
                />
              </div>

            </div>
          </div>
        </li>



          </div>
        </li>

        {/* Common Agent Combos Accordion */}
        <li>
          <input type="checkbox" name="accordian" id="Indiv-Bind-Gekko-Common-Agent-Combos" />
          <label htmlFor="Indiv-Bind-Gekko-Common-Agent-Combos">Common Agent Combos</label>
          <div className="accordian__content"><p>Content about common agent combos...</p></div>
        </li>

      </ul>
    </main>



      {/* Footer Section */}
      <section className="footer-section">
        <Footer />
      </section>
    </div>
  );
};

export default BindGekko;
